import { forwardRef, type Ref, type SVGProps } from "react";

function SvgQuizRequired(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#quiz_required_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path stroke="#0D2B57" strokeLinecap="round" d="M67 34.25h42m-42 10h42" />
      <rect width={39} height={39} x={106} y={54.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={106} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M131 78s-.889 1.03-1.889 1.03-1.805-.953-2.787-.953c-.981 0-1.597.536-1.991.953m4.472-10.559 1.057 1.058c.26.26.26.682 0 .942l-8.667 8.667a.67.67 0 0 1-.471.195H119V77.61c0-.176.07-.346.195-.47l8.667-8.668c.26-.26.682-.26.943 0"
      />
      <defs>
        <linearGradient
          id="quiz_required_svg__a"
          x1={88}
          x2={88}
          y1={13}
          y2={107}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgQuizRequired);
export default ForwardRef;
